import React from "react";

import QuickForm from "../../utilities/quick-form/quick-form";
import CssInput from "../../utilities/quick-form/custom-inputs/css-input";
import { FontFam, Theme } from "../../../models/models";
import { acceptedMediaExtensions } from "../../../models/models";
import { fontFamilies } from "../../../services/font.service";
import { StorageContext } from "../../storage/storage-context"
// import QuillMediaModal from "../../../../components/utilities/quick-form/custom-inputs/quill-input/quill-media-modal";

import FileBrowser from "../../file-browser/file-browser";

const ThemeFontModal: React.FC<{ init: FontFam, resolve: (value: { fontFam: FontFam } | null) => any }> = ({init, resolve}) => {

  const [storageContext] = React.useContext(StorageContext);

  const [fontToggle, setFontToggle] = React.useState<boolean>(false);
  const [fontFamily, setFontFamily] = React.useState<string>(init.family || Object.values(fontFamilies).flat()[0] );
  const [customFont, setCustomFont] = React.useState<string>();
  const [formErrors, setFormErrors] = React.useState<string[]>([]);

  return (
    <div className={`p-2 bg-gradient-to-br from-blue-500 to-pink-500`}>
      <div>
        {
          !fontToggle ?
            <div className="flex px-2 py-16">
              <QuickForm<{ fontFamily: string }> 
                schema={{
                  fontFamily: { type: Object.values(fontFamilies).flat(), attributes: { required: true }, meta: { quickForm: {
                    hideErrorMessages: true,
                    inputClassName: `${(storageContext.theme as Theme).forms.primary} p-2`
                  }}}
                }}
                init={{ fontFamily: fontFamily }}
                onInput={(errors, model) => { (fontFamily !== model.fontFamily) && (() => { setFormErrors(errors); setFontFamily(model.fontFamily) })() }} 
                labelPlacement={"none"}
              />
              <button 
                className="btn btn-primary"
                onClick={() => resolve({ fontFam: { family: fontFamily }})}
              >Select</button>
              <button 
                className="btn btn-accent"
                onClick={() => setFontToggle(true)}
              >Pick Custom Font</button>
            </div>
          :
            <div>
              <button
                className="btn btn-accent"
                onClick={() => setFontToggle(false)}
              >Pick Default Fonts</button>
              <FileBrowser 
                acceptedMediaExtensions={{ font: ['.woff2', '.woff', '.ttf', '.otf'] }}
                sources={{ 
                  'Disc': {
                    readDirectoryRoute: 'getdirectory',
                    // createDirectoryRoute: 'createdirectory',
                    // deleteMediaRoute: 'deletemedia',
                    uploadMediaRoute: 'uploadmedia'
                  }
                }}
                onPick={(filePath, metaData) => resolve({ fontFam: { src: filePath }})}
              />
            </div>
        }
      </div>
    </div>
  );
};

export default ThemeFontModal;